import { MESFMain } from "@dexteel/mesf-core";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "material-icons";
import "material-symbols";
import "react-datepicker/dist/react-datepicker.css";
import { createRoot } from "react-dom/client";
import "./setup/ag-grid-license";

import { AuthenticationConfig } from "./setup/auth-config";
import { customConfigurations } from "./setup/configurations";
import { CustomNavbar } from "./setup/navbar";
import { CustomRoutes } from "./setup/routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <QueryClientProvider client={queryClient}>
    <MESFMain
      routes={CustomRoutes}
      navbar={CustomNavbar}
      navbarTitle={"RBD MS"}
      configurations={customConfigurations}
      authentication={AuthenticationConfig}
      byPassHeaderRoutes={[
        "/scrap-charges/selection",
        "/scrap-charges/operation",
        "/billets-yard-inventory-touch",
      ]}
    />
  </QueryClientProvider>,
);
